<template>
    <v-container grid-list-xs fluid @contextmenu.prevent="$refs.menuGo.open($event)">

        <v-row>
            <v-col class="text-center">
                <v-row>
                    <v-col cols="6">
                        <label>
                            <h2>Net income and revenue by region</h2>
                        </label>
                        <Bar :chart-options="chartOptions" :chart-data="general" chart-id="doughnut-chart"
                            dataset-id-key="label" />
                    </v-col>
                    <v-col cols="6">
                        <label>
                            <h2>Margin by region</h2>
                        </label>
                        <Bar :chart-options="chartOptions" :chart-data="margin" chart-id="doughnut-chart"
                            dataset-id-key="label" />
                    </v-col>
                </v-row>
            </v-col>
            <v-col class="text-center">
                <v-row>
                    <v-col cols="6">
                        <label>
                            <h2>Count shifts by region</h2>
                        </label>
                        <Bar :chart-options="chartOptionsY" :chart-data="totalsShifts" :chart-id="'bar-chart'"
                            dataset-id-key="label" />
                    </v-col>
                    <v-col cols="6">
                        <label>
                            <h2>Count orders by region</h2>
                        </label>
                        <Bar :chart-options="chartOptionsY" :chart-data="totalsOrders" :chart-id="'bar-chart'"
                            dataset-id-key="label" />
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row class="text-center">
            <v-col>
                <label>
                    <h2>Net income by geographical region</h2>
                </label>
                <Bar :chart-options="chartOptions" :chart-data="subgeneral" :chart-id="'bar-chart'"
                    dataset-id-key="label" />
            </v-col>
        </v-row>

        <v-dialog v-model="dialog" scrollable fullscreen persistent transition="dialog-transition">
            <v-card>
                <shift_analysis :dashboard="true" v-if="view == 1" @close="dialog = false;" @drilldown="drilldown(2)">
                </shift_analysis>
                <drill_down :dashboard="true" @close="view = 1;" v-if="view == 2" @drilldown="drilldown(3)">
                </drill_down>
                <transacting :dashboard="true" @close="view = 2;" v-if="view == 3"></transacting>
            </v-card>
        </v-dialog>

        <vue-context ref="menuGo" dense>
            <template slot-scope="selected">
                <v-list density="compact" dense>
                    <v-list-item dense @click="dialog = true">
                        <v-icon>mdi-google-analytics</v-icon>
                        <v-list-item-title v-text="'Show ShiftAnalysis'"></v-list-item-title>
                    </v-list-item>
                </v-list>
            </template>
        </vue-context>

    </v-container>
</template>

<script>
import axios from 'axios';
import shift_analysis from './../Analytics/ShiftAnalyticsDetails.vue';
import drill_down from './../Analytics/DrillDownLevel.vue';
import transacting from './../Analytics/AnalyticsTransacting.vue';
import { Line as LineChartGenerator } from 'vue-chartjs/legacy';
import { Bar } from 'vue-chartjs/legacy';
import { Doughnut } from 'vue-chartjs/legacy';
import { Scatter } from 'vue-chartjs/legacy';
import VueContext from 'vue-context';
import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    LineElement,
    LinearScale,
    CategoryScale,
    PointElement,
    ArcElement,
    BarElement,
} from 'chart.js';

ChartJS.register(
    Title,
    Tooltip,
    Legend,
    LineElement,
    LinearScale,
    CategoryScale,
    PointElement,
    BarElement,
    ArcElement
);

export default {
    props: ['year','order','typeBy'],
    components: {
        LineChart: LineChartGenerator,
        Bar,
        Doughnut,
        Scatter,
        shift_analysis,
        drill_down,
        transacting,
        VueContext
    },
    watch: {
        '$store.state.analytics.StartTime': function () {
            this.getDataDash();
        },

        '$store.state.analytics.EndTime': function () {
            this.getDataDash();
        },
        'typeBy': function () {
            this.getDataDash();
        },
        
        'order': function () {
            this.getDataDash();
        },
    },
    data: function () {
        return {
            dialog: false,
            view: 1,
            top: [],
            margin:[],
            bottom: [],
            general: null,
            subgeneral: null,
            totalsShifts: {},
            totalsOrders: {},
            report: 'Shift',
            type: 'Net',
            types: ['Revenue', 'OtherRev', 'Expenses', 'OtherExp', 'Net'],
            chartOptions: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        display: true,
                        position: 'left' // Coloca las etiquetas a la izquierda
                    }
                }
            },
            chartOptionsX: {
                responsive: true,
                maintainAspectRatio: false,
                indexAxis: 'y',
                scales: {
                    x: {
                        beginAtZero: true
                    }
                }
            },
            chartOptionsY: {
                responsive: true,
                maintainAspectRatio: false,
                indexAxis: 'x',
                scales: {
                    x: {
                        stacked: false
                    },
                    y: {
                        beginAtZero: true
                    }
                }
            }
        }
    },
    mounted() {
        this.getDataDash();
        this.$store.state.analytics.url = 'shift-analytics/region-totals';
        this.$store.state.analytics.title = "View Regions Totals";
    },
    methods: {
        drilldown(view) {
            this.view = view;
        },
        getDataDash: function () {
            let str = this.$store;
            str.state.isLoading = true;
            const parms = {
                StartDate: this.$store.state.analytics.StartTime,
                EndDate: this.$store.state.analytics.EndTime,
                TypeBy: this.typeBy,
                OrderBy : this.order.id
            }
            axios
                .post('dashboard/region/dash', parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(async response => {
                    this.general = await this.dataMultiBarData(response.data['general'], 'PrincipalRegion',['Net','Revenue'], 'Net Amount');
                    this.margin = await this.dataBar(response.data['general'], 'PrincipalRegion', 'Margin', 'Net Amount');
                    this.subgeneral = await this.dataBar(response.data['subgeneral'], 'Region', 'Net', 'Net Amount');
                    this.totalsShifts = await this.dataMultiBar(response.data['countShifts'], 'Shifts', 'Total', 'Total Shifts By Region');
                    this.totalsOrders = await this.dataMultiBar(response.data['countOrders'], 'Orders', 'Total', 'Total Shifts By Region');
                    console.log(this.totalsShifts, this.general);
                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    str.state.isLoading = false;
                    console.log(error);
                });
        },
        dataDoughnut(data, label, value, title) {
            const labels = data.map(x => {
                return x[label];
            });
            const values = data.map(x => {
                return x[value];
            });
            const colors = data.map(x => {
                console.log(x[value]);
                switch(x.PrincipalRegionID){
                    case 1:
                        return '#4A148C';
                    break;
                    case 2:
                        return '#3F51B5';
                    break;
                    case 3:
                        return '#009688';
                    break;
                }
                if(x.PrincipalRegionID == 1){
                }
            });
            const row = {
                labels: labels,
                datasets: [
                    {
                        label: title,
                        backgroundColor: colors,
                        data: values
                    }
                ]
            }
            return row;
        },
        dataBar(data, label, value, title) {
            const labels = data.map(x => {
                return x[label];
            });
            const values = data.map(x => {
                return x[value];
            });
            const row = {
                labels: labels,
                datasets: [
                    {
                        data: values,
                        label: title,
                        backgroundColor: '#0D47A1',
                        fill: false
                    }
                ]
            }
            return row;
        },
        dataMultiBarData(data, label, valx, title) {
            const labels = data.map(x => {
                return x[label];
            });
            let datasets = [];
            
            const colors = ['#0D47A1','#4A148C'];
            valx.forEach((vls,idx) => {
                const values = data.map(x => {
                    return x[vls]
                });
                const dataset = {
                    data: values,
                    label: vls,
                    backgroundColor: colors[idx],
                    fill: false
                }
                datasets.push(dataset);
            });
            const row = {
                labels: labels,
                datasets: datasets
            }
            return row;
        },
        eliminarDuplicados: function (arr) {
            const uniqueElements = new Set();
            return arr.filter(item => {
                const serializedItem = JSON.stringify(item);
                if (!uniqueElements.has(serializedItem)) {
                    uniqueElements.add(serializedItem);
                    return true;
                }
                return false;
            });
        },
        async dataMultiBar(data, label, value, title) {
            const shift = ['AM', 'PM'];
            const headers = data.map(x => {
                return x.PrincipalRegion;
            });
            const labels = await this.eliminarDuplicados(headers);
            console.log(labels);
            const rows = {
                labels: labels,
                datasets: []
            }
            const colorPm = '#0D47A1';
            const colorAm = "#FFB300";

            shift.forEach(dt => {
                const values = data.filter(y => {
                    return dt == y.Shift;
                }).map(x => {
                    return x[value];
                });
                let row;
                if (dt == 'AM') {
                    row =
                    {
                        data: values,
                        label: dt,
                        backgroundColor: colorAm,
                        fill: false
                    }
                } else {
                    row =
                    {
                        data: values,
                        label: dt,
                        backgroundColor: colorPm,
                        fill: false
                    }
                }
                rows.datasets.push(row);
            });
            console.log('here', rows);
            return rows;
        },
        getRandomColor() {
            return `#${Math.floor(Math.random() * 16777215).toString(16)}`;
        }
    }
};
</script>
